/* =========================================================================
   WWC CRO-concept - meting

   Duwt gebeurtenissen naar window.dataLayer zodat GTM/GA4 ze oppikt. Geen
   eigen netwerkverkeer, geen extra script van derden: als GTM er niet is,
   blijft de array gewoon staan en gebeurt er verder niets.

   WAAROM DEZE VIJF
   We kunnen nu wel zien DAT 97% niets in de winkelwagen legt, maar niet waar
   ze op vastlopen. Deze vijf maken de productpagina afleesbaar:

     wwc_faq_open        welke vraag wordt geopend -> welke twijfel leeft echt
     wwc_crosssell_click werkt de gelegenheden-sortering, of klikt men toch
                         gewoon op de goedkoopste
     wwc_lightbox_open   wordt de galerij serieus bekeken
     wwc_material_open   hoeveel mensen openen de materiaalkiezer, en wisselen
     wwc_sticky_buy      koopt men via de meelopende balk of via de knop zelf

   Alles is gedelegeerd op document, dus blokken die later verschijnen doen
   vanzelf mee - geen herbinding nodig.
   ========================================================================= */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function push(event, data) {
    try {
      var payload = { event: event };
      for (var k in data) { if (data[k] !== undefined) payload[k] = data[k]; }
      payload.product_id = (window.WWC_CRO_PDP && window.WWC_CRO_PDP.productId) || null;
      payload.product_type = (window.WWC_CRO_PDP && window.WWC_CRO_PDP.productType) || null;
      payload.city = (window.WWC_CRO_PDP && window.WWC_CRO_PDP.city) || null;
      window.dataLayer.push(payload);
    } catch (e) { /* meting mag nooit de pagina breken */ }
  }

  /* --- Hulpjes voor richting ---------------------------------------------
     Op EEN plek, want vorm, materiaal en maat stellen alle drie dezelfde
     vraag: ging de klant naar duurder of naar goedkoper? Zonder dat is een
     klikaantal een getal zonder betekenis. */
  function getal(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }

  function richting(van, naar) {
    if (van === null || naar === null) return null;
    if (naar > van) return 'op';
    if (naar < van) return 'af';
    return 'gelijk';
  }

  function cents(kaart) {
    if (!kaart) return null;
    var el = kaart.querySelector('[data-mat-cents]');
    return el ? el.getAttribute('data-mat-cents') : null;
  }

  function schoon(el) {
    if (!el) return null;
    /* De prijs staat in dezelfde knoop als de naam; die eruit halen, anders
       komt er "Noten €79" in de meting te staan. */
    var prijs = el.querySelector && el.querySelector('.wwc-material-option__price');
    var t = el.textContent || '';
    if (prijs) t = t.replace(prijs.textContent, '');
    return t.replace(/\s+/g, ' ').trim() || null;
  }

  /* --- 1. FAQ: welke vraag wordt geopend ---------------------------------
     Op 'toggle' luisteren en niet op 'click': het name-attribuut klapt andere
     vragen automatisch dicht, en die sluitingen willen we niet meetellen. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains('wwc-hub2__item')) return;
    if (!d.open) return;
    var q = d.querySelector('.wwc-hub2__q');
    var groep = d.closest('.wwc-hub2__list');
    var kop = groep && groep.previousElementSibling && groep.previousElementSibling.classList.contains('wwc-hub2__group')
      ? groep.previousElementSibling.textContent.trim() : null;
    push('wwc_faq_open', {
      vraag: q ? q.textContent.replace(/\s+/g, ' ').trim() : null,
      groep: kop
    });
  }, true);

  /* --- 2. Gebouwenlijst: apart, want dit is een andere twijfel ----------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains('wwc-cro-buildings')) return;
    if (!d.open) return;
    push('wwc_buildings_open', {
      aantal: d.querySelectorAll('.wwc-cro-buildings__chip').length
    });
  }, true);

  /* --- 3. Cross-sell: welke kaart, op welke plek -------------------------
     positie telt vanaf 1 en is de gerenderde volgorde, dus die vertelt of de
     sortering op gedeelde cadeaumomenten daadwerkelijk beter werkt dan prijs. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.wwc-rel2__card');
    if (!card) return;
    var row = card.parentElement;
    var idx = row ? Array.prototype.indexOf.call(row.children, card) + 1 : null;
    push('wwc_crosssell_click', {
      positie: idx,
      naar_type: (card.querySelector('.wwc-rel2__type') || {}).textContent || null,
      naar_url: card.getAttribute('href')
    });
  }, true);

  /* --- 4. Materiaalkiezer: openen en wisselen ---------------------------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains('wwc-material-picker')) return;
    if (!d.open) return;
    push('wwc_material_open', {
      aantal_opties: d.querySelectorAll('.wwc-material-option').length
    });
  }, true);

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.wwc-material-option');
    if (!opt) return;
    /* RICHTING, niet alleen bestemming. "Noten" zegt niets over op of af; de
       vraag die we willen beantwoorden is of mensen naar een duurdere of naar
       een goedkopere uitvoering gaan. De centen staan al in de DOM op
       [data-mat-cents]; ze werden alleen niet meegestuurd. */
    /* data-mat-cents staat op het PRIJS-element binnen de kaart, niet op de
       kaart zelf - nagemeten 17 aug 2026. Het is de absolute prijs in centen
       (4900, 5900), niet het verschil, dus van/naar vergelijken kan gewoon. */
    var centNaar = getal(cents(opt));
    var huidig = document.querySelector('.wwc-material-option.is-current');
    var centNu = getal(cents(huidig));
    push('wwc_material_switch', {
      naar_url: opt.getAttribute('href'),
      naar_naam: schoon(opt.querySelector('.wwc-material-option__name')),
      van_naam: schoon(huidig && huidig.querySelector('.wwc-material-option__name')),
      cent_van: centNu,
      cent_naar: centNaar,
      richting: richting(centNu, centNaar)
    });
  }, true);

  /* --- 5. Lightbox en koopknoppen ---------------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-gal-slide]') && !e.target.closest('button, a')) {
      push('wwc_lightbox_open', {});
      return;
    }
    var sticky = e.target.closest && e.target.closest('[data-wwc-sticky-buy] button, [data-wwc-sticky-buy] a');
    if (sticky) {
      /* MODUS EN UITKOMST. De balk houdt zijn stand al bij in data-mode
         (buy/choose/soldout, gezet door setMode in wwc-cro.js), maar dit script
         las dat attribuut niet. Gevolg: "ik koop via de balk" en "de balk
         stuurt me terug omdat er nog een verplicht veld leeg is" waren
         hetzelfde getal - precies de vraag die dit event moest beantwoorden. */
      var bar = e.target.closest('[data-wwc-sticky-buy]');
      var modus = (bar && bar.getAttribute('data-mode')) || 'onbekend';
      push('wwc_sticky_buy', {
        modus: modus,
        uitkomst: modus === 'buy' ? 'toegevoegd' : (modus === 'soldout' ? 'uitverkocht' : 'teruggestuurd')
      });
      return;
    }
    var cta = e.target.closest && e.target.closest('.cz-choice__cta');
    if (cta) {
      /* De balk koopt door cta.click() aan te roepen, en dat is een ECHTE
         bubbelende klik - dus deze handler vuurde ook, en elke aankoop via de
         balk telde dubbel onder twee namen. wwc-cro.js zet de vlag vlak voor
         de synthetische klik en haalt hem in de volgende tick weg. */
      if (window.__wwcSyntheticCta) return;
      push('wwc_buy_click', { label: (cta.textContent || '').trim().slice(0, 40) });
    }
  }, true);
})();
